var _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgLightning = function SvgLightning(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id, ")"),
    d: "m11.461 4.895-.601-.448.601.448Zm-4.307 5.79.602.447-.602-.448Zm2.629-4.79a.75.75 0 0 0 1.203.895l-1.203-.896Zm-.95 3.79a.75.75 0 0 0-1.204-.896l1.203.896Zm9.573 1.535-.602-.448.602.448Zm-7.66 10.296-.603-.448.602.448ZM5.593 12.78l-.602-.447.602.447Zm7.66-10.296.603.448-.602-.448Zm-.389.12v7.617h1.5V2.604h-1.5Zm-2.68 10.225h-4.19v1.5h4.19v-1.5Zm.95 8.567V13.78h-1.5v7.617h1.5Zm6.67-10.624-7.662 10.296 1.204.895 7.66-10.296-1.203-.895Zm-3.99.4h4.19v-1.5h-4.19v1.5Zm-1.752-5.83 1.794-2.41-1.204-.895-1.793 2.41 1.203.895Zm-5.867 7.886 1.56-2.096-1.204-.896-1.56 2.097 1.204.895Zm4.79-6.438 1.077-1.448-1.203-.895-1.077 1.447 1.203.896Zm-3.23 4.342 1.076-1.447-1.203-.896-1.077 1.447 1.204.896Zm11.252.535c.613-.824.025-1.996-1.003-1.996v1.5a.25.25 0 0 1-.2-.4l1.203.896Zm-9.373 9.73c0 .914 1.166 1.3 1.712.566l-1.204-.895a.55.55 0 0 1 .992.328h-1.5Zm.55-7.068a.55.55 0 0 1-.55-.55h1.5a.95.95 0 0 0-.95-.95v1.5Zm-4.19-1.5a.25.25 0 0 1 .2.4l-1.203-.896c-.613.824-.025 1.996 1.003 1.996v-1.5Zm6.87-2.608c0 .525.426.95.95.95v-1.5a.55.55 0 0 1 .55.55h-1.5Zm1.5-7.617c0-.915-1.166-1.301-1.712-.567l1.204.895a.55.55 0 0 1-.992-.328h1.5Z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 5,
    x2: 19,
    y1: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  })))));
};
export default SvgLightning;